<template>
  <div>
    <v-modal
      :position="!screen.breakPoint.tabPort ? 'bottom' : 'top'"
      :fit-content="!screen.breakPoint.tabPort"
      :animation="!screen.breakPoint.tabPort ? 'slide-up' : 'slide-down'"
      :full="!screen.breakPoint.tabPort"
      handle-click-bg
      v-model="show"
    >
      <template #header>
        {{$t('views.Profile.deletingAccount')}}
      </template>

      <div class="text--center">
        {{ $t('views.Profile.deletingAccountEmailUs') }}
        <br>
        <br>
        <a href="mailto:info@merchantstore.services">info@merchantstore.services</a>
      </div>
    </v-modal>
  </div>
</template>

<script>
import vModal from '@/ui/modals/vModal'

import screen from '@/mixins/screen'

import { notifyGraphqlError } from '@/mixins/handleGraphqlError'
import { removePinToken } from '@/mixins/pinToken'

export default {
  mixins: [screen, notifyGraphqlError, removePinToken],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  components: {
    vModal
  },

  computed: {
    show: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style>
.mw400{
  max-width: 400px;
}
</style>
